import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box } from '@src/components';

// typing

// style
const style = css`
    > .info {
        ${mixin.row}
        ${mixin.lastState}
    }
`;

// component
export class LastState extends Proto<Props, State> {

	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data } = this.state;
        const { last_state } = data;
        
		return (
            <div className={style}>
                <section className="info">
                    <article className="state">
                        <figure>
                            <span className="fa fa-warning" />
                        </figure>
                        <div>
                            <h4>{ _('laststate_title', 'BatteryCycle') }</h4>
                            <table className="table"><tbody>
                            <tr>
                                <td>{ _('laststate_type', 'BatteryCycle') }</td>
                                <td>{"TODO"}</td>
                            </tr>
                            <tr>
                                <td>{ _('laststate_code', 'BatteryCycle') }</td>
                                <td>{"TODO"}</td>
                            </tr>
                            <tr>
                                <td>{ _('laststate_description', 'BatteryCycle') }</td>
                                <td>{"TODO"}</td>
                            </tr>
                            </tbody></table>
                        </div>
                    </article>
                    
                    <article className="actions">
                        <figure>
                            <span className="fa fa-list" />
                        </figure>
                        <div>
                            <h4>{ _('laststate_actions_title', 'BatteryCycle') }</h4>
                            <table className="table"><tbody>
                            {/*last_state.actions.map( (a,i) => (
                            <tr key={i}>
                                <td>{a}</td>
                            </tr>
                            )) TODO */}
                            </tbody></table>
                        </div>
                    </article>
                </section>
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/BatteryCycle/LastState.tsx